import { Design } from '../document2/page/surface/design/design';
import { Layer } from '../document2/page/surface/design/layer/layer';
import { DebugHelper } from "@/helper/debugHelper";
import { ImageHelper } from '@/helper/imageHelper';
import { RasterImageLayer } from '../document2/page/surface/design/layer/rasterImageLayer';
import { NativeHelper } from '@/helper/nativeHelper';
import { NameHelper } from '@/helper/nameHelper';

// DL版ではOSクリップボードとのやりとりも行う
export class ClipboardManager
{
    // アプリ内クリップボードのデータ
    private _appClipboardData : any | null = null;

    public copy(object : any, doCopy : boolean = true) : boolean
    {
        var result = false;
        if(object instanceof Design)
        {
            if(doCopy) { this._appClipboardData = object.clone(); }
            result = true;
        }
        else if(object instanceof Layer)
        {
            if(doCopy) { this._appClipboardData = object.clone(); }
            result = true;
        }
        else if(object instanceof Array)
        {
            var copyObject = new Array();
            for(var i = 0; i < object.length; ++i)
            {
                var obj = object[i];
                if(obj instanceof Design)
                {
                    copyObject.push(obj.clone());
                }
                else if(obj instanceof Layer)
                {
                    copyObject.push(obj.clone());
                }
            }

            if(copyObject.length > 0)
            {
                if(doCopy) { this._appClipboardData = copyObject; }
                result = true;
            }
        }

        return result;
    }

    public canCopy(object : any)
    {
        return this.copy(object, false);
    }

    // デザイン配列として取得
    public getAsDesignArray() : Array<Design> | null
    {
        var array = new Array();
        if(this._appClipboardData instanceof Array)
        {
            for(var i = 0; i < this._appClipboardData.length; ++i)
            {
                var data = this._appClipboardData[i];
                if(data instanceof Design) { array.push(data.clone()); }
            }
        }
        else if(this._appClipboardData instanceof Design)
        {
            array.push(this._appClipboardData.clone());
        }
        return array.length > 0 ? array : null;
    }

    public canGetAsDesignArray()
    {
        return this.getAsDesignArray() != null;
    }

    // デザインとして取得
    public getAsDesign() : Design | null
    {
        var array = this.getAsDesignArray();
        if(array != null && array.length > 0)
        {
            return array[0];
        }
        return null;
    }

    public canGetAsDesign()
    {
        return this.getAsDesign() != null;
    }

    // レイヤー配列として取得
    public getAsLayerArray() : Array<Layer> | null
    {
        var array = new Array();
        if(this._appClipboardData instanceof Array)
        {
            DebugHelper.trace(this._appClipboardData.length)
            for(var i = 0; i < this._appClipboardData.length; ++i)
            {
                var data = this._appClipboardData[i];
                if(data instanceof Layer) { array.push(data.clone()); }
            }
        }
        else if(this._appClipboardData instanceof Layer)
        {
            array.push(this._appClipboardData.clone());
        }
        return array.length > 0 ? array : null;
    }

    public canGetAsLayerArray()
    {
        return this.getAsLayerArray() != null;
    }

    // レイヤーとして取得
    public getAsLayer() : Layer | null
    {
        var array = this.getAsLayerArray();
        if(array != null && array.length > 0)
        {
            return array[0];
        }
        return null;
    }

    public canGetAsLayer()
    {
        return this.getAsLayer() != null;
    }

    // 外から画像をデータをクリップボードに与える
    // imageData : base64 * Rasterに限る
    // design : 現在のデザイン
    public setImageData(imageData : string, design : Design, completion : () => void)
    {
        // 空、SVGは読み込まない
        if(imageData == "" || ImageHelper.isSvg(imageData)) 
        {
            completion();
            return; 
        }
        // 画像サイズ取得
        ImageHelper.getImageSize(imageData, size => 
        {
            var imageWidth = size.width;
            var imageHeight = size.height;

            var fitSize = ImageHelper.fitImageSize(
                {width : imageWidth, height : imageHeight}, 
                { width : design.width / 2, height : design.height / 2});

            // 白色透明画像の作成
            ImageHelper.createWhiteTransparentImage(imageData, (whiteTransparentImage) => {
                // ラスター画像レイヤーの作成
                var x = (design.width - fitSize.width) / 2;
                var y = (design.height - fitSize.height) / 2;
                var layer = RasterImageLayer.create(imageData, x, y, fitSize.width, fitSize.height);
                layer.setWhiteTransparentImage(whiteTransparentImage);
                layer.name = NameHelper.createLayerName("image", design)
                // レイヤーをクリップボードにコピー
                this._appClipboardData = layer;
                // 完了処理
                completion();
            }); 
        });
    }
}